import { render } from "./UIPasswordInput.vue?vue&type=template&id=7c15b34b"
import script from "./UIPasswordInput.vue?vue&type=script&lang=ts"
export * from "./UIPasswordInput.vue?vue&type=script&lang=ts"
script.render = render

export default script